import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { RoutesService, ShuttlesService, TicketsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TDealership, TResponse, TRoute } from '@shared/models';

@Component({
    'selector': 'app-routeView',
    'templateUrl': './routeView.page.html',
    'styleUrls': ['./routeView.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class RouteViewPage extends ViewBasePage implements OnInit, OnDestroy {
    public route: TRoute;
    // public route: TRoute = {
    //     shuttle: null,
    //     endingPoint: null,
    //     routeLegs: [],
    //     createdDate: this.dateService.getMinimumDate(),
    //     selectedTickets: [],
    //     startingPoint: null,
    //     uid: ''
    // };
    public dealership: TDealership;

    constructor(private routesService: RoutesService, 
        private ticketsService: TicketsService, private shuttlesService: ShuttlesService,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ROUTE_VIEW);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            this.dealership = this.sessionService.getDealership();
            const obj: any = super.getViewModel();
            this.route = obj.route;

            this.initMoreMenu();
        } catch (err) {
            throw new Error('Error in routeView.ngOnInit() ');
        }
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        // Make certain that only assignedShuttles can have their routes deleted.
        if (this.route.shuttle.status === 'Assigned') {
            this.pushPopoverMenuItem('Delete Route', 'delete-route-tour');
        }
        this.pushPopoverMenuItem('Show Tour', 'show-route-view-tour');

        this.moreMenuItemClick((menuItem: any) => {
            switch (menuItem.name) {
                case 'Delete Route':
                    this.onConfirmDeleteRouteClick();
                    break;
            }
        });
    }

    public async onConfirmDeleteRouteClick() {
        const title = 'Confirm Route Deletion';
        let msg = 'Deleting this route will reset the tickets in this route back to pending.  ';
        msg += 'Are you sure you want to delete this route?';

        const response = await this.uxHelperService.showAlert(title, msg);
        if (response.okay) {
            try {
                await this.uxHelperService.showSpinner();
                await this.deleteRoute();
            } catch (err) {
                const errorMessage = this.utilsService.extractError(err);
                this.uxHelperService.showAlert('Error', errorMessage);
            } finally {
                await this.uxHelperService.hideSpinner();
                this.router.navigateByUrl('/routes');

                msg = 'Tickets are now pending and route info has been deleted.';
                this.uxHelperService.showToast(msg);
            }
        }
    }

    // This method is not and should not be used in production by an end user.
    // This method is only for me to do debugging.
    // private async setAllTicketsToPending() {
    //     await this.shuttlesService.setAllShuttlesToIdle();
    //     await this.ticketsService.setAllTicketsToPending();
    //     await this.routesService.deleteAll();

    //     const msg = 'All tickets are now pending and all routes have been deleted ';
    //     this.uxHelperService.showToast(msg);
    // }

    private async deleteRoute() {
        this.route.selectedTickets.forEach(ticket => {
            this.ticketsService.setTicketToPending(ticket);
        });
        await this.shuttlesService.updateShuttleToIdle(this.route.shuttle.uid);
        await this.routesService.delete(this.route.uid);

        // So the view will display nothing.
        this.route.selectedTickets = [];
        this.route.shuttle = null;

        const msg = 'This route has been deleted and all associated tickets are now pending.';
        this.uxHelperService.showToast(msg);
    }
}
